import { t } from "i18next"
import * as Yup from "yup"

export const validationFile = Yup.object().shape({
  excelFile: Yup.mixed().required(t("global.you_must_select_a_file", "You must select a file"))
})
export const validationSelectedFields = Yup.object().shape({
  internNumber: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_internnr", "You must enter intern no")),
  name: Yup.string().nullable().required(t("global.you_must_enter_customer", "You must enter customer")),
  assignmentNr: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_the_contract_number", "You must enter the contract number")),
  nrOfHours: Yup.string().nullable().required(t("global.you_must_specify_hours", "You must specify hours")),
  dateFrom: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_start_date", "You must enter a start date")),
  dateTo: Yup.string().nullable().required(t("global.you_must_enter_end_date", "You must enter an end date"))
})
